import React, {Component} from 'react';
import {gpn} from "../GPN"
import axios from "axios";
import config from "../config";
import Field from "../sections/MUI/Field";
import Back from "../sections/Back";
import Button from "../sections/MUI/Button";
import {toast} from "react-toastify";

class EditUser extends Component {

    state = {
        id: "",
        firstName: "",
        lastName: "",
        gender: "مرد",
        phoneNumber: "",
        ref: "",

        orders: []
    };

    componentDidMount() {
        this.getUser();
    }

    getUser() {
        axios.get(`${config.api}/admin/user?token=${config.token}&id=${this.props.params.id}`)
            .then(r => {
                const {user, orders} = r.data.result;
                this.setState({
                    id: user.id,
                    firstName: user.firstName,
                    lastName: user.lastName,
                    gender: user.gender,
                    phoneNumber: user.phoneNumber,
                    ref: user.ref,
                    orders
                });
            })
            .catch(err => {
                config.handleError(err);
            });
    }

    edit() {
        const {id, firstName, lastName, gender} = this.state;

        let params = new URLSearchParams();
        params.append("id", id);
        params.append("firstName", firstName);
        params.append("lastName", lastName);
        params.append("gender", gender);
        toast.info("در حال ویرایش ...")
        axios.put(`${config.api}/admin/user?token=${config.token}`, params)
            .then(r => {
                toast.success("با موفقیت ویرایش شد.");
                this.getUser();
            })
            .catch(err => {
                config.handleError(err);
            });
    }

    render() {
        const {id, firstName, lastName, gender, phoneNumber, ref, orders} = this.state;
        return (
            <div className="edit-user">
                <Back {...this.props}/>

                <div className="row justify-content-center">
                    <div className="col-md-6">
                        <Field name="firstName"
                               value={firstName}
                               maxLength={150}
                               label="نام"
                               onChange={(name, value) => this.setState({[name]: value})}/>
                    </div>
                    <div className="col-md-6">
                        <Field name="lastName"
                               value={lastName}
                               maxLength={150}
                               label="نام خانوادگی"
                               onChange={(name, value) => this.setState({[name]: value})}/>

                    </div>
                    <div className="col-md-6">
                        <div className="gender">
                            <div className="title">جنسیت:</div>
                            <div className="row">
                                <div className="col-6">
                                    <div className={gender === "مرد" ? "item active" : "item"}
                                         onClick={() => this.setState({gender: "مرد"})}>مرد
                                    </div>
                                </div>
                                <div className="col-6">
                                    <div className={gender === "زن" ? "item active" : "item"}
                                         onClick={() => this.setState({gender: "زن"})}>زن
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <p className="phone-number">{phoneNumber}</p>
                    </div>

                    <div className="col-md-5">
                        <Button submit={false} icon="edit" onClick={() => this.edit()}>ویرایش کردن</Button>
                    </div>
                </div>


                <br/>
                <h2>سفارشات</h2>
                <div className="orders">
                    {orders.map((o, i) =>
                        <article key={"order" + i}>
                            {
                                o.service ?
                                    <div className="service">
                                        <span
                                            onClick={() => this.props.navigate(`/service/${o.service.id}`)}>{o.service.title}</span><span>{config.priceFormatter(o.service.price)}</span>
                                    </div> :
                                    null
                            }
                            <div className="address">{o.address}</div>

                            {o.expert ?
                                <div className="expert" onClick={() => this.props.navigate(`/expert/${o.export.id}`)}>
                                    <div className="row">
                                        <div className="col-auto">
                                            <div className="image"><img src={o.expert.personalPhoto} alt=""/></div>
                                        </div>
                                        <div className="col">
                                            <div className="full-name"><span>{o.expert.firstName}</span>&nbsp;
                                                <span>{o.expert.lastName}</span></div>
                                            <div className="phone-number">{o.expert.phoneNumber}</div>
                                        </div>
                                    </div>

                                </div>
                                : null}
                            {
                                o.region ?
                                    <div className="region">
                                        <div className="title">محله:&nbsp;{o.region.title}</div>
                                    </div> : null

                            }

                            <div className="price">
                                <span>جمع کل:</span>
                                <span>{config.priceFormatter(o.price)}</span>
                            </div>
                        </article>
                    )}
                </div>
            </div>
        );
    }
}

export default gpn(EditUser);